// extracted by mini-css-extract-plugin
export default {"actionModalContainer":"message-actions-modal_actionModalContainer__EPs1L","actionsContainer":"message-actions-modal_actionsContainer__CV3U-"};